import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
* {
  margin: 0;
  padding: 0;
  border: 0;
  vertical-align: baseline;
  box-sizing:border-box;
  -webkit-tap-highlight-color: transparent;
}

body {
  font-family: "Pretendard";
  font-size: 16px;
  overflow-y: auto;
  overflow-x: hidden;
  width: 100%;
  margin:auto;
  height: calc(var(--vh, 1vh) * 100);
  background-color: #ffffff;
}

abbr[title] {
  text-decoration: none;
}
  
nav, section {
  display: block;
}

ol, ul {
  list-style: none;
}


a {
  display: inline-block;
  text-decoration: none;
  color: initial;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}


input, textarea, button {
  outline: none;
  font-family: inherit; 
}

button {
  line-height: 1;
}

textarea {
  resize:none;
}


h1, h2, h3 {
  display:none;
}
`;
